import { useEffect } from 'react';
import { Form, Modal } from 'antd';
import { parentFlagReasons } from '@/stores/data';
import Select from '@/components/select';

const FlagModal = ({ open, loading, onSave, onClose }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    await onSave(values.reason);
    onClose();
  };

  return (
    <Modal
      title="Change flag"
      open={open}
      okText="Save"
      confirmLoading={loading}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
          <Select options={parentFlagReasons} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FlagModal;
